import react, { useState, useEffect } from 'react'

import { CircularProgress, TableContainer, Paper, Table, TableRow, TableCell, TableBody, Typography, useTheme, IconButton } from '@mui/material'
import SavedSearchIcon from '@mui/icons-material/SavedSearch';
import SendIcon from '@mui/icons-material/Send';
import { fetchGoogleDriveFolder, googleDriveFileUrl } from './googleDriveApi'
import BackgroundImage, { implyAspectRatio } from './BackgroundImage'

const BOARD_MEMBERS = [
  {
    name: "Cathy Ingram-Kelly",
    email: "",
    title: "President",
    coor: null
  },
  {
    name: "Katlyn Ramos Cooper",
    email: "",
    title: "Vice-President, Chamber of Commerce",
    coor: null
  },
  {
    name: "Valerie O'Connor",
    email: "",
    title: "Secretary",
    coor: null
  },
  {
    name: "Dennis Freitas",
    email: "",
    title: "Treasurer",
    coor: null
  },
  {
    name: "Rebecca Weill",
    email: "sanpedrobryte@gmail.com",
    title: "\"Friends of San Pedro\"",
    coor: null
  },
  {
    name: "Larry Freitas",
    email: "sanpedroparkrentals@gmail.com",
    title: "Park Rentals/Coordination",
    coor: null
  },
  {
    name: "Angie Ramos",
    email: "",
    title: "Holy Ghost Festas Liaison",
    coor: null
  },
  {
    name: "Kevin Fereira",
    email: "",
    title: "Brick Memorial Garden Chair",
    coor: null
  },
  {
    name: "Silvestre Gilmete",
    email: "",
    title: "Cabo Verde Liaison/Veteran's Day Parade",
    coor: null
  },
  {
    name: "Christina Velez",
    email: "",
    title: "Holy Cross Church liaison",
    coor: null
  },
  {
    name: "Karin McClelland",
    email: "",
    title: "Brick Memorial Garden Chair",
    coor: null
  }
]

function BoardImageOverlay({ width, aspectRatio, selectedMember }) {
  const height = `calc(${width} * ${aspectRatio})`
  const Ring = ({ member }) => {
    console.log(member)
    let cx, cy;
    BOARD_MEMBERS.forEach(m => {
      if (m.name == member.name) {
        [cx, cy] = m.coor
      }
    })
    cx = `calc(${width} * ${cx})`
    cy = `calc(${height} * ${cy})`
    const r = `calc(${width} * 0.05)`
    const color = member.color
    return <circle cx={cx} cy={cy} r={r} stroke={color} strokeWidth="5" fill="none" />
  }

  return (
    <div
      id="board-image-overlay"
      style={{
        position: "absolute",
        width: width,
        height: height
      }}
      onClick={(event) => {
        const divBox = document.getElementById("board-image-overlay").getBoundingClientRect()
        const deltaX = (event.clientX - divBox.x) / divBox.width
        const deltaY = (event.clientY - divBox.y) / divBox.height
        console.log([deltaX, deltaY])
      }}
    >
      <svg width={width} height={height}>
        {selectedMember && selectedMember.name && <Ring member={selectedMember} />}
      </svg>
    </div>
  )
}

function BoardImage({ selectedMember }) {
  const width = "45vw"
  return (
    <div style={{
      position: "relative"
    }}>
      <BoardImageOverlay selectedMember={selectedMember} width={width} aspectRatio={2 / 3} />
      <BackgroundImage src={require("../assets/BoardofDirectors24.jpg")} width={width} aspectRatio={2 / 3} />
    </div>
  )
}

function BoardTable({ setSelectedMember, selectedMember }) {
  const width = 45

  const isSelected = (member) => {
    return selectedMember && selectedMember.name == member.name
  }
  return (
    <div style={{
      width: `${width}vw`
    }}>
      <TableContainer component={Paper}>
        <Table aria-label="simple table" padding="none">
          <TableBody>
            {BOARD_MEMBERS.map((row) => (
              <TableRow
                key={row.name}
              >
                <TableCell>
                  <IconButton
                    size="large"
                    color="inherit"
                    style={{
                      margin: "0px 10px",
                    }}
                    disabled={row.coor === null}
                    onClick={() => {
                      isSelected(row) ?
                        setSelectedMember({}) :
                        setSelectedMember({ name: row.name, color: 'red' })
                    }}
                  >
                    <SavedSearchIcon style={isSelected(row) ? { fill: "red" } : {}} />
                  </IconButton>
                </TableCell>
                <TableCell>{row.name}</TableCell>
                <TableCell>{row.title}</TableCell>
                <TableCell>{row.email}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}

export default function BoardOfDirectors() {
  const [selectedMember, setSelectedMember] = useState()
  return (
    <div style={{
      display: "flex",
      flexDirection: "row",
      paddingLeft: "40px",
      paddingRight: "40px",
      gap: "40px",
      alignItems: "center",
      marginTop: 40,
      marginBottom: 40
    }}>
      <BoardImage selectedMember={selectedMember} />
      <BoardTable setSelectedMember={setSelectedMember} selectedMember={selectedMember} />
    </div>
  )
}